import React from "react"
import styled from "styled-components"
import Label from "../../Label"
import Section from "../../Section"
import { LazyResImage } from "../../../common/responsive"

const PressContainer = styled.div`
  display: block;
  width: 100%;
  position: relative;
  max-width: 900px;
  margin: 0 auto;
  text-align: center;
`

const PressMentions = styled.div`
  display: block;
  text-align: center;
  max-width: 900px;
  margin: 0 auto;
`

const PressMention = styled.div`
  text-align: center;
  display: block;
  width: 100%;

  @media (min-width: 500px) {
    display: inline-block;
    width: auto;
    margin: 11px 22px;
  }
`

const PressLink = styled.a`
  display: block;
  position: relative;
`

const Logo = styled.img`
  display: inline-block;
  height: ${props => props.height || "22px"};
  max-width: 100%;
  margin: 11px 0;

  @media (min-width: 500px) {
    margin: 6px 0;
    height: auto;
    max-width: none;
  }
`

const Press = ({ headline, mentions }) => (
  <Section small color="neutralLightest">
    <PressContainer>
      <Label>{headline}</Label>
      <PressMentions>
        {mentions.map((mention, index) => (
          <PressMention key={index}>
            <PressLink href={mention.url} target="_blank">
              <LazyResImage
                src={mention.logo}
                height={mention.height}
                alt={`Buoy Health is featured by ${mention.publisher}.`}
              >
                <Logo />
              </LazyResImage>
            </PressLink>
          </PressMention>
        ))}
      </PressMentions>
    </PressContainer>
  </Section>
)

export { Press as default }



// WEBPACK FOOTER //
// ./src/components/Press/components/Press.js